import { motion } from "motion/react";
import { Check } from "lucide-react";

interface AnswerOptionProps {
  text: string;
  isSelected: boolean;
  onClick: () => void;
}

export function AnswerOption({ text, isSelected, onClick }: AnswerOptionProps) {
  return (
    <motion.button
      onClick={onClick}
      className={`w-full p-4 rounded-2xl text-left transition-all relative overflow-hidden cursor-pointer ${
        isSelected
          ? "tailwind-button border-2 balance-test-button"
          : "tailwind-button-selected border-2 border-transparent balance-test-button"
      }`}
      whileHover={{ scale: 1.01 }}
      whileTap={{ scale: 0.99 }}
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
    >
      <div className="flex items-center justify-between gap-3">
        <span className="flex-1 leading-relaxed">{text}</span>
        {isSelected && (
          <motion.div
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{ type: "spring", stiffness: 500, damping: 25 }}
            className="flex-shrink-0"
          >
            <div className="w-6 h-6 rounded-full bg-[var(--warm-accent)] flex items-center justify-center">
              <Check className="w-4 h-4 text-white" />
            </div>
          </motion.div>
        )}
      </div>
    </motion.button>
  );
}